import { GET_CONTRACTS } from '../actionTypes';
import { Contract } from '../reducers/clients';

export const getContractsAction = (contracts: Contract[]) => ({ type: GET_CONTRACTS, payload: contracts})